var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-compare__field"
  }, [_vm.attrib.bool ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "bool-icon mr-2 text-responsive text-center"
  }, [_c('font-awesome-icon', {
    class: _vm.attrib.value ? 'text-success' : 'text-danger',
    attrs: {
      "icon": _vm.attrib.value ? 'check-circle' : 'times-circle'
    }
  })], 1)]) : _vm.attrib.justImg ? _c('div', [_c('b-img', {
    attrs: {
      "src": _vm.imgPath + _vm.attrib.img,
      "fluid": ""
    }
  })], 1) : _c('div', {
    staticClass: "card-compare__field__value"
  }, [_c('div', {
    staticClass: "card-compare__field__value__text"
  }, [_vm._v(_vm._s(_vm.attrib.valueLabel))]), _c('b-progress', {
    staticClass: "card-compare__field__value__progress",
    attrs: {
      "max": 1,
      "height": "0.75rem"
    }
  }, [_c('b-progress-bar', {
    attrs: {
      "value": _vm.attrib.value / _vm.attrib.maxValue,
      "variant": _vm.progressVariant(_vm.attrib.value, _vm.attrib.maxValue, _vm.attrib.lessIsMore)
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }